import React, { useState, useEffect } from 'react';
import styles from 'feature/splash/index.module.sass';
import Lottie from 'react-lottie';
import { useAppContext } from 'use-app';
import { useHistory, useLocation } from 'react-router';
import appLoader from 'distributor/app-loader';
import loadingBar from 'lottie/loading-bar.json';
import autopassTextStatic from 'lottie/autopass-logo.json';
import autopassTextAnimate from 'lottie/autopass-splash.json';
import classnames from 'classnames/bind';
import axios from 'axios';
import Maintenance from 'components/maintenance';
import { maintenanceConfigUrl } from 'config';
const cx = classnames.bind(styles);

const SplashPage = () => {
  const { state, dispatch } = useAppContext();
  const [isInit, setIsInit] = useState();
  const history = useHistory();
  const location = useLocation();
  const { methods } = appLoader;
  const [maintenanceConfig, setMaintenanceConfig] = useState(null);

  useEffect(() => {
    axios
      .get(maintenanceConfigUrl, {
        timeout: 2000,
      })
      .then(res => {
        let data = res.data.default;

        if (data['all'].enabled) {
          setMaintenanceConfig(data['all']);
        } else if (data.hasOwnProperty('web')) {
          setMaintenanceConfig(data['web']);
        } else {
          setMaintenanceConfig({ enabled: false });
        }
      })
      .catch(err => {
        console.log(err);
        setMaintenanceConfig({ enabled: false });
      });
  }, []);

  useEffect(() => {
    if (!maintenanceConfig || maintenanceConfig.enabled) return;

    methods.useSplash({ state, dispatch, history, location }, () => setTimeout(() => setIsInit(true), 700));
  }, [maintenanceConfig]); //eslint-disable-line

  return (
    <>
      {maintenanceConfig && maintenanceConfig?.enabled && (
        <Maintenance title={maintenanceConfig.title} content={maintenanceConfig.content} />
      )}
      <SplashLoading isInit={isInit} />;
    </>
  );
};

export const SplashLoading = ({ isInit }) => {
  const splashClass = cx({
    splash: true,
    init: isInit,
  });
  return (
    <div className={splashClass}>
      <div className={styles.lottie}>
        <div className={styles.text}>
          <Lottie
            width={250}
            options={{
              loop: false,
              animationData: isInit ? autopassTextAnimate : autopassTextStatic,
            }}
          />
        </div>
        <div className={styles.bar}>
          <Lottie
            width={250}
            options={{
              animationData: loadingBar,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default SplashPage;
